/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const MANDATE_BASE_LINK = '/admin/mandates'

export function getMandateCreateLink (params?: Record<string, unknown>) {
  return `${MANDATE_BASE_LINK}/create?${stringify(params)}`
}

export function getMandateLink (id: number) {
  return `${MANDATE_BASE_LINK}/${id}/edit`
}

export function getMandateLinkTemplate () {
  return `${MANDATE_BASE_LINK}/{id}/edit`
}

export function getMandateListLink (params?: Record<string, unknown>) {
  return `${MANDATE_BASE_LINK}?${stringify(params)}`
}
